import I18N from 'i18n-js';
const I18n = window.I18n || I18N;
I18n.translations || (I18n.translations = {});
I18n.translations["fr"] = I18n.extend((I18n.translations["fr"] || {}), {
  "autoflow": {
    "add": "Ajouter",
    "next": "Suivant",
    "operators": {
      "or": "OU"
    }
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Facebook Job enregistré avec succès."
      },
      "google": {
        "fill_out": "Veuillez remplir toutes les données requises dans les paramètres de la campagne.",
        "save_success": "Google Jobs enregistré avec succès."
      },
      "landing_page": {
        "add_url": "Ajouter une URL",
        "cancel": "Annuler",
        "custom_landing_page_description": "Générez de nouvelles URL et attribuez un nom de source à chaque URL. Les candidats qui effectuent une présélection sur l'URL seront suivis avec votre nom de source personnalisé. Les noms de source courants sont le nom du site et le nom du recruteur attribué, le nom de l'événement.",
        "custom_landing_page_title": "Personnaliser la source de la page de destination",
        "custom_source_label": "Nom de la source",
        "date_created": "date de création",
        "invalid_url": "URL de redirection non valide",
        "landing_pages": "Pages de destination",
        "landing_pages_desc": "Par défaut, la page de destination est suivie en tant que \"Page de destination\" dans le point de données source. Vous pouvez nommer une URL de page de destination comme source personnalisée ci-dessous.",
        "redirect_after": "Rediriger après",
        "redirect_url": "Rediriger l'URL",
        "refresh_rate_min_error": "Le taux de rafraîchissement doit être d'au moins 1 seconde.",
        "reload_redirect": "Rediriger / Recharger",
        "save_success": "La page de destination a bien été enregistrée.",
        "seconds": "Secondes",
        "source_placeholder": "Ex. Site de Washington",
        "source_title": "Suivre une source personnalisée",
        "url_copy": "URL copiée dans le presse-papiers"
      },
      "messenger": {
        "copy_url": "Copier le lien",
        "create_messenger_source_url": "Créer une URL",
        "create_messenger_source_url_success": "L'URL de Messenger a été créée avec succès.",
        "default_input_source_value": "La Source",
        "default_select_option_value": "Sélectionner...",
        "facebook_pages": "Pages Facebook",
        "messenger_link": "Lien Messenger",
        "messenger_source_url_description": "Les candidats qui utilisent cette URL Messenger seront suivis avec cette source.",
        "messenger_source_url_title": "Suivre une source personnalisée dans l'URL de Messenger",
        "page_title": "Page Facebook",
        "previously_created_messenger_urls": "URL Messenger créées précédemment",
        "previously_created_messenger_urls_description": "Voici toutes les URL Messenger créées précédemment pour cette campagne.",
        "select_pages": "Sélectionnez les pages Facebook pour répertorier cette campagne sur Messenger, puis cliquez sur Enregistrer pour appliquer vos modifications.",
        "source_label": "La Source",
        "source_title": "Suivre une source personnalisée"
      },
      "tecoloco_jobs": {
        "fill_out": "Veuillez remplir toutes les données requises dans les paramètres de la campagne.",
        "save_success": "Tecoloco Jobs saved successfully"
      }
    }
  },
  "campaigns": {
    "edit": {
      "form": {
        "job_type": "Type d'emploi",
        "job_type_options": {
          "contract": "Contrat",
          "fixed_term": "Durée déterminée",
          "full_time": "À plein temps",
          "internship": "Stage",
          "part_time": "À temps partiel",
          "probationary": "Probatoire",
          "project": "Projet",
          "regular": "Ordinaire",
          "seasonal": "Saisonnier",
          "volunteer": "Bénévole"
        },
        "location": "Emplacement",
        "salary": "Salaire"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Partager"
        }
      }
    },
    "buttons": {
      "proceed": "Procéder",
      "submit": "Envoyer"
    },
    "labels": {
      "no_results": "Pas de données disponibles"
    },
    "modals": {
      "continue": "Continuer"
    },
    "options": {
      "deleted": "Supprimé",
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATS APP"
    },
    "toastr": {
      "actions": {
        "failed": "Cette action n'a pas été traitée avec succès.",
        "success": "Cette action a été traitée avec succès."
      }
    },
    "upload": "Importer"
  },
  "companies": {
    "settings": {
      "buttons": {
        "delete": "Supprimer"
      },
      "team": {
        "role_permissions": {
          "manager": "Responsable"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "dim",
      "lun",
      "mar",
      "mer",
      "jeu",
      "ven",
      "sam"
    ],
    "abbr_month_names": [
      null,
      "jan.",
      "fév.",
      "mar.",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ],
    "day_names": [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%d/%m/%Y",
      "long": "%e %B %Y",
      "short": "%e %b"
    },
    "month_names": [
      null,
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "environ une heure",
        "other": "environ %{count} heures"
      },
      "about_x_months": {
        "one": "environ un mois",
        "other": "environ %{count} mois"
      },
      "about_x_years": {
        "one": "environ un an",
        "other": "environ %{count} ans"
      },
      "almost_x_years": {
        "one": "presqu'un an",
        "other": "presque %{count} ans"
      },
      "half_a_minute": "une demi-minute",
      "less_than_x_minutes": {
        "one": "moins d'une minute",
        "other": "moins de %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "moins d'une seconde",
        "other": "moins de %{count} secondes"
      },
      "over_x_years": {
        "one": "plus d'un an",
        "other": "plus de %{count} ans"
      },
      "x_days": {
        "one": "1 jour",
        "other": "%{count} jours"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 mois",
        "other": "%{count} mois"
      },
      "x_seconds": {
        "one": "1 seconde",
        "other": "moins de %{count} secondes"
      }
    },
    "prompts": {
      "day": "Jour",
      "hour": "Heure",
      "minute": "Minute",
      "month": "Mois",
      "second": "Seconde",
      "year": "Année"
    }
  },
  "eos": {
    "campaign": {
      "applicant_scoring": {
        "applicant_scoring": {
          "add": "Ajouter",
          "candidate_attribute": "Caractéristiques du candidat",
          "description": "Select Candidate Attributes and assign a weight percentage to each one for a total ot 100% for the Applicant Score or this Campaign.",
          "dropdown_hint": "Select an Attribute from the list",
          "title": "Job Matching",
          "weight": "Weight"
        },
        "description": "Configure a Scoring System for this Campaign by assigning a weight to a Candidate Attribute (Geolocation, TalkScore English Proficiency and Multiple Choice Questions) and then setting up the scores for each item.",
        "error": "Job Matching was not saved. Please try again.",
        "item_scoring": {
          "candidate_attribute": "Caractéristiques du candidat",
          "description": "Set up a score parameter to each of the items from 0 to 100%. In this case, a 100% means that a candidate with that particular parameter will get the full score allocated in the Job Matching tab",
          "empty": "No Candidate Attributes have been set up yet. Add Candidate Attributes and assign a weight to them first in the Job Matching tab",
          "hint": {
            "geolocation": "Distance from Campaign Location as set in the Campaign Main Settings",
            "multiple": "To edit these Items. Edit the options for this question in the Question tabs.",
            "talkScore": ""
          },
          "items": "Items and Score Parameters",
          "title": "Item Scoring",
          "value_label": {
            "geopoint": "Within"
          }
        },
        "shared": {
          "cancel": "Annuler",
          "candidate": "Caractéristiques du candidat",
          "save": "Enregistrer"
        },
        "success": "Job Matching was saved successfully.",
        "title": "Job Matching",
        "weight_error": "Weight distribution has to add up 100%"
      },
      "label": {
        "add_button": "Ajouter un lien",
        "add_question_set": "Add a Question Set",
        "banner": "Bannière",
        "call_to_action": "Prochaine étape",
        "cancel": "Annuler",
        "completion_message": "Message de fin",
        "copy": "Copier",
        "create_button": "Créer un lien",
        "crop": "Recadrer",
        "facebook_pixel_id": "Pixel ID Facebook",
        "google_tag_container_id": "ID de conteneur Google Tag Manager",
        "landing_page_type": "Type de page web",
        "landing_page_url": "URL de la page web",
        "new_landing_page_design": "Design de la page web",
        "prescreening_questions": "Prescreening Questions",
        "redirect_url": "URL de redirection",
        "text_displayed": "Texte affiché"
      },
      "talkscore": {
        "weight_distribution": {
          "description": "Set up a Weight Distribution per TalkScore parameter  from 0 to 100% for this campaign. This weight Distribution will be used to calculate the Overall Score of the application and for the Job Matching System.",
          "error": "TalkScore Settings were not saved. Please try again.",
          "subtitle": "Score Parameters",
          "success": "TalkScore Settings were saved successfully.",
          "title": "TalkScore Settings"
        }
      },
      "text": {
        "active_cta_limit": "Limite maximum du nombre de liens actifs .",
        "add_cta": "Ajouter liens au dernier écran ",
        "add_cta_info": "Lien écran de fin pour rediriger les candidats vers vos réseaux sociaux ou pour effectuer une action. Vous pouvez créer jusqu’à trois liens à la fois. ",
        "allowed_banner_files": "Types de fichiers autorisés : jpg, png, jpeg. %{file_size} (ko) maximum.",
        "apply_new_design": "Utilisez la page web avec le nouveau design pour cette campagne.",
        "banner_notice": "Utiliser la bannière standard, suivant les paramètres de votre compte sur toutes les campagnes.",
        "banner_required": "Ce champ est obligatoire.",
        "button_limit_reached": "Limite de liens atteinte",
        "click_on_dropdown": "Cliquez sur le menu déroulant pour en savoir plus ",
        "custom_source_guide": "Par défaut, la \"page web\" est marquée comme la source. Vous pouvez personnaliser la source ci-dessous.",
        "default_banner_use": "Si aucune bannière n'est ajoutée, la bannière standard sauvegardée dans les paramètres du compte sera utilisée",
        "delete_set_confirmation": "Are you sure you want to remove this question set from this campaign?",
        "incomplete_details": "Détails incomplets",
        "internal_server_error": "Désolé, nous rencontrons un problème de serveur interne. Veuillez réessayer plus tard.",
        "invalid_url": "%{url} n'est pas une URL valide",
        "landing_page_type": {
          "multiple": {
            "description": "Une question par écran",
            "title": "Une question par écran"
          },
          "single": {
            "description": "Toutes les questions sont affichées sur une seule page.",
            "title": "Formulaire long"
          }
        },
        "landing_pages": "Pages web",
        "nothing_to_update": "Rien à mettre à jour.",
        "page_type_notice": "Vous avez déjà sélectionné un type %{type} de page web pour toutes vos campagnes dans vos paramètres compte",
        "question_set_consistency": "By using a Question Set, you can ensure consistency across multiple Campaigns. To edit them, go to the Question Set tab in Templates.",
        "recommended_banner": "%{width}px x %{height}px recommandé.",
        "response_resubmit": {
          "disabled": "Disable the back button to prevent resubmissions (Not applicable to Onboarding campaigns)",
          "enabled": "Enable the back button to allow resubmissions (Not applicable to Onboarding campaigns)"
        },
        "select_question_set": "Select a Question Set to add",
        "shown_end_form": "Affiché à la fin du formulaire.",
        "updated_successfully": "Mis à jour avec succés.",
        "view_selected_set_info": "View the Selected Question Set, remove it from this Campaign or replace it by another existing set. To edit the questions directly, go to the Question Set Templates tab."
      }
    },
    "company": {
      "label": {
        "color_theme": "Schéma des couleurs",
        "default_banner": "Bannière par défaut",
        "landing_page_sop_up_screen": "Landing Page Pop-up Screen",
        "primary": "Primaire",
        "secondary": "Secondaire",
        "shade": "Couleur"
      },
      "listings": {
        "button": {
          "cancel": "Annuler",
          "save": "Enregistrer",
          "upload": "Importer"
        },
        "description": "This page is where your selected job application campaigns are displayed, letting candidates view your job openings and apply through their respective Landing Pages",
        "input": {
          "label": {
            "banner": "Bannière",
            "banner_allowed_types": "Allowed file types: jpg, jpeg and png.",
            "banner_recommended_size": "1280px x 400px",
            "copied": "Copied to Clipboard",
            "header_char_count": "%{count}/60 characters",
            "listings_url": "Job Listing Page URL",
            "page_header": "Page Header"
          },
          "placeholder": {
            "page_header": "Search Job Openings at %{company}"
          }
        },
        "messages": {
          "error": "Settings were not saved. Please try again.",
          "success": "Settings were saved successfully."
        },
        "page": {
          "button": {
            "apply": "Postuler",
            "first": "First",
            "last": "Dernier",
            "search": "Trouver des emplois"
          },
          "input": {
            "keywords": "Keywords",
            "location": "Localisation",
            "remote": "Télétravail"
          },
          "label": {
            "default_header": "Search Job Openings at %{company}",
            "go_to_top": "Go to the top",
            "job_count": "Displaying %{count} of %{total} jobs",
            "no_results": "No Results",
            "salary_undisclosed": "non dévoilé"
          },
          "source": "Site carrière"
        },
        "title": "Site carrière"
      },
      "text": {
        "apply_new_design": "Utilisez la page web avec le nouveau design pour toutes les campagnes.",
        "apply_page_type": "Par défaut, utilisez ce type de page web pour toutes les campagnes. Cette option peut être désactivée dans les paramètres de chaque campagne.",
        "default_banner": "Si aucune bannière n'est téléchargée dans une campagne, la bannière standard sera utilisée.",
        "default_banner_use": "Utilisez la bannière par défaut dans toutes les campagnes. Si elle est sélectionnée, l'option sera désactivée dans les paramètres de campagne.",
        "enter_custom_color": "Vous pouvez également entrer des valeurs de code HEX dans les champs de texte principal et secondaire.",
        "landing_page_sop_up_screen": "This will be displayed as a pop-up in the Landing Pages before candidates input their information.",
        "select_color_palette": "Sélectionnez les couleurs du thème de couleurs de la page d'accueil à l'aide de la palette et des curseurs ci-dessous."
      }
    },
    "facebook_page": {
      "record": {
        "button": {
          "disconnect": "Disconnect",
          "login": "LOG IN WITH FACEBOOK",
          "renew": "Renew",
          "renew_all": "Renew All"
        },
        "label": {
          "actions": "Actions",
          "audit": {
            "system": {
              "disconnected": "Disconnected on %{date}",
              "last_renew": "Last Renewed on %{date}"
            },
            "user": {
              "disconnected": "Disconnected by %{user} on %{date}",
              "last_renew": "Last Renewed by %{user} on %{date}"
            }
          },
          "confirmation": {
            "disconnect": {
              "text": "In order to reconnect a page after it has been disconnected, click on the Log in to Facebook button and follow the steps to re-authenticate it.",
              "title": "Disconnect Facebook Page"
            }
          },
          "create": {
            "error": "Erreur",
            "success": "Succès"
          },
          "disconnect": {
            "error": "Erreur",
            "success": "Succès"
          },
          "expiresAt": "Expiration Date",
          "facebook_id": "Identifiant",
          "lead_ads_warning": {
            "contact": "or contact Product Support for assistance.",
            "learn_more": "Learn more here",
            "learn_more_url": "https://help.talkpush.com/en/articles/8892130-renew-or-disconnect-your-facebook-page-access-from-talkpush",
            "testing_tool": "Test your Lead Ads integration.",
            "text": "You will need to have the right level of access to renew the Facebook and WhatsApp tokens. Check the list of required permissions to make sure that the bots and Lead Ads integrations will function properly.",
            "title": "Attention"
          },
          "login": {
            "error": "Log In Error"
          },
          "name": "Nom",
          "no_data": "Cliquez pour remplir",
          "renew": {
            "error": "Erreur",
            "success": "Succès"
          },
          "required_permissions": "Required Permissions",
          "resubscribe": {
            "error": "Error updating. Please try again.",
            "success": "The access token for %{pages} successfully renewed."
          },
          "status": "Statut",
          "title": "Facebook Page Access"
        },
        "status": {
          "active": "Actif",
          "expired": "expiré",
          "expiring_soon": "Expiring Soon",
          "invalid": "Invalid",
          "tooltip": {
            "active": "In order to use the dashboard features for this page, click on the Log in to Facebook button and follow the steps to re-authenticate it.",
            "expired": "This token has expired. Click on the Log in to Facebook button and follow the steps to re-authenticate it.",
            "invalid": "This token has been invalidated by Facebook due to an authentication issue. Click on the Log in to Facebook button and follow the steps to re-authenticate it."
          }
        }
      }
    },
    "guest": {
      "label": {
        "add": "Add Guest",
        "create": {
          "desc": "Configure guests in order to easily share Candidate profiles with them via Email or WhatsApp",
          "error": "An error ocurred, please try again later",
          "required_value": "Add at least one communication method to reach this Guest in order to save.",
          "success": "Guest Created Successfully",
          "title": "Create Guest"
        },
        "name": "Nom",
        "new": {
          "title": "New Guest"
        },
        "no_results": "No Results",
        "phone_number": "Numéro de téléphone",
        "role": "Rôle",
        "search": "Search Guests",
        "update": {
          "success": "Guest Updated Successfully",
          "title": "Update Guest"
        }
      }
    },
    "landing_page": {
      "communication_channels": {
        "email": "E-mail",
        "errors": {
          "field_required": "%{field} required."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Besides email, what is the best way to get hold of you and update you on the next steps?",
        "whatsapp": "WhatsApp"
      },
      "consent": "This site only uses session cookies which is essential to be able to navigate the site and use its features and functionalities. No personally identifiable data is collected by session cookies.",
      "label": {
        "audio": "Réponse audio",
        "click_download": "Cliquez ici pour télécharger",
        "continue": "Continuer",
        "contract": "Contrat",
        "copy_it": "Copier",
        "email": "E-mail",
        "email_it": "Envoyez par e-mail",
        "error": "Erreur",
        "facebook": "Facebook",
        "file_upload": "Télécharger le fichier",
        "first_name": "Prénom",
        "fixed_term": "Durée déterminée",
        "full_time": "À plein temps",
        "get_started": "Commencer",
        "internship": "Stage",
        "job_type": "Type d'emploi",
        "last_name": "Nom",
        "location": "Localisation",
        "new_recording": "Nouvel enregistrement",
        "next": "Suivant",
        "no_answer": "No Answer",
        "part_time": "À temps partiel",
        "pause": "Pauser",
        "phone_number": "Numéro de téléphone",
        "picture": "Photo",
        "play": "Lire",
        "play_recording": "Lire l'enregistrement",
        "post_it": "Postez-le",
        "probationary": "Probatoire",
        "proceed": "Procéder",
        "project": "Projet",
        "record_now": "Enregistrer maintenant",
        "regular": "Ordinaire",
        "retake_picture": "Reprendre la photo",
        "retry": "Retry",
        "salary": "Salaire",
        "save": "Enregistrer",
        "seasonal": "Saisonnier",
        "share": "Partager",
        "share_it": "Partager",
        "snap_photo": "Photo instantanée",
        "start_camera": "Démarrer la caméra",
        "start_recording": "Commencer l'enregistrement",
        "stop": "Arrêter",
        "stop_recording": "Arrêter d'enregistrer",
        "submit": "Envoyer",
        "take_picture": "Prendre une photo",
        "text": "Texte",
        "tweet_it": "Twitter ",
        "undisclosed": "non dévoilé",
        "upload": "Importer",
        "upload_again": "Upload Again",
        "upload_time": "Uploading video might take a while, please wait.",
        "view_open_positions": "View Open Positions",
        "view_sample": "Afficher",
        "volunteer": "Bénévole",
        "warning": "Attention",
        "whatsapp": "WhatsApp",
        "your_progress": "Etat d'avancement "
      },
      "persistent_privacy_policy_link": {
        "click": "Click <a target=\"_b\" href=\"https://talkpush.com/privacy/\">here</a> to read their privacy policy.",
        "info": "We use a third-party service called Talkpush to help us collect the information we need to screen applicants and make recruitment decisions."
      },
      "text": {
        "about_company": "En savoir plus sur %{company}",
        "about_our_company": "Qui somme nous? ",
        "application_invalid": "Candidature invalide",
        "camera_not_permitted": "L'accès à la caméra est bloqué.",
        "close_to_new_applications": "This job is no longer accepting applications. Click on the button below to view all open positions.",
        "close_warning": "In case of leaving this questionnaire before its completion, it can be completed on a later attempt, but no previously provided answer/record will be visible or editable.",
        "completion_message": "Vous avez rempli et soumis avec succès votre candidature pour %{job}. Merci!",
        "contact_channel": "Quel est le  meilleur moyen de me contacter au sujet de ma candidature ?",
        "copied_succesfully": "Copié avec succès",
        "dropdown_instruction": "Select an option",
        "generic_browser_error": "Impossible d'enregistrer le média. Assurez-vous qu'il existe un périphérique de capture multimédia accessible et que vous utilisez le navigateur le plus récent et le plus moderne pour une meilleure expérience.",
        "instructions": "Instruction(s) : %{text}",
        "invalid_location": "Entre une localisation valide.",
        "job_type_options": {
          "contract": "Contrat",
          "default": "Postuler pour connaître le type d'emploi",
          "fixed_term": "Durée déterminée",
          "full_time": "À plein temps",
          "internship": "Stage",
          "part_time": "À temps partiel",
          "probationary": "Probatoire",
          "project": "Projet",
          "regular": "Ordinaire",
          "seasonal": "Saisonnier",
          "volunteer": "Bénévole"
        },
        "mic_not_permitted": "L'accès au microphone est bloqué.",
        "min_max_char": "Entry should be %{min} character(s) minimum and %{max} characters maximum",
        "no_camera": "Aucune caméra disponible.",
        "no_media_device": "Aucun périphérique multimédia accessible.",
        "no_mic": "Aucun micro disponible.",
        "no_supported_mimetype": "Il n'y a pas de type de support MIME pris en charge dans ce navigateur et la qualité d'enregistrement peut en souffrir. Essayez de passer à un autre navigateur ou appareil.",
        "not_supported_browser": {
          "text": "Click the three dot menu at the top right corner of the screen and open this link on your preferred browser to continue.",
          "title": "You won’t be able to complete this questionnaire in the Facebook browser."
        },
        "our_social_media": "Nos médias sociaux",
        "play_media": {
          "answer": "played",
          "instruction": "Click play to begin, then click the 'next' button to move to the next question.",
          "local_storage_not_present": "Browser not supported"
        },
        "pop_up_privacy_policy": "By clicking Continue, you are agreeing to the <a href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider. This will automatically check the box in the form.",
        "privacy_policy": "J'accepte la <a target=\"_b\" href=\"%{policy_url}\">politique de confidentialité</a> de %{company} et la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">politique de confidentialité</a> du fournisseur de services.",
        "privacy_policy_talkpush": "J'accepte la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">politique de confidentialité</a> du fournisseur de services.",
        "privacy_policy_url": "https://talkpush.com/privacy-applicant/",
        "processing_answers": "Please give us a moment while we process your answers.",
        "question_progress": "%{current} sur %{size}",
        "rate_your_experience": "Évaluez votre expérience",
        "receive_updates": "Je souhaite recevoir des mises à jour par SMS, Facebook, Messenger ou WhatsApp.",
        "remote_types": {
          "fully_remote": "Entièrement en télétravail",
          "temporarily_remote": "Temporairement en télétravail",
          "wfh_flexible": "Télétravail flexible"
        },
        "salary_types": {
          "annually": "Annuellement",
          "biweekly": "Bihebdomadaire",
          "daily": "tous les jours",
          "hourly": "Hourly",
          "monthly": "Mensuel",
          "one-time": "Une fois",
          "weekly": "hebdomadaire"
        },
        "share_with_network": "Share with your network",
        "size_of_mb": "%{size} de 20 Mo",
        "talkscore_instructions": "Recordings should have a minimum of 30 seconds and a maximum of 1 minute. Make sure that the audio is clear and there is no background noise.",
        "thank_you": "Merci",
        "trouble_playing_response": "Tu as du mal à lire cette réponse?",
        "upload": {
          "error": {
            "failed": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, click Retry to process it again.",
              "title": "Oops! There was a problem while processing this document."
            },
            "max_retries": {
              "text": "You have reached the maximum number of retries for this document. Click next to continue to the next question or submit to finish this part of your process.",
              "title": "Oops! This does not look like the document we asked for."
            },
            "not_supported": "Some files cannot be uploaded",
            "partially_recognized": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, continue with the next question.",
              "title": "Make sure this is the document we asked for."
            },
            "recognition_error": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, click Retry to process it again.",
              "title": "Oops! There was a problem while processing this document."
            },
            "unrecognized": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, continue with the next question.",
              "title": "Oops! One of your documents does not look like the document we asked for."
            },
            "upload_error": {
              "text": "Please try again.",
              "title": "Oops! We encountered a problem while trying to upload your document."
            }
          },
          "file_invalid_type": "Le format de fichier doit être .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "La taille du fichier doit être inférieure à 10 Mo.",
          "status": {
            "failed": "Not Recognized",
            "partially_recognized": "Not Recognized",
            "processing": "Processing",
            "recognition_error": "Not Recognized",
            "recognized": "Recognized",
            "unrecognized": "Not Recognized",
            "upload_error": "Upload Error",
            "uploaded": "Uploaded"
          },
          "success": "Your document has been recognized. Click to continue with the next question."
        },
        "upload_failed": "There was an error while uploading your response. Please try again.",
        "video_limit": "La durée de réponse vidéo maximale est de 1 minute."
      }
    },
    "message": {
      "editor": {
        "controls": {
          "alignment": {
            "buttons": {
              "center": "Align Center",
              "left": "Alight Left",
              "right": "Align Right"
            }
          },
          "basic_format": {
            "bold": "Bold",
            "italic": "Italic",
            "underline": "Underline"
          },
          "call_to_action": {
            "buttons": {
              "add": "Add Button",
              "cancel": "Annuler",
              "edit": "Edit Button",
              "remove": "Remove Button",
              "save": "Enregistrer"
            },
            "labels": {
              "link": "Link",
              "text": "Text to display",
              "token": "Select a token from the list"
            },
            "link_types": {
              "link": "Link",
              "token": "Link Token"
            }
          },
          "emoji": {
            "labels": {
              "emoji": "Emoji"
            }
          },
          "font_size": {
            "buttons": {
              "add": "Font Size"
            }
          },
          "image": {
            "buttons": {
              "add": "Ajouter"
            },
            "labels": {
              "image": "Image",
              "paste_image_url": "Paste Image URL"
            }
          },
          "link": {
            "buttons": {
              "add": "Add Link",
              "cancel": "Annuler",
              "edit": "Edit Link",
              "remove": "Remove Link",
              "save": "Enregistrer"
            },
            "labels": {
              "link": "Link",
              "text": "Text to display",
              "token": "Select a token from the list"
            },
            "link_types": {
              "link": "Link",
              "token": "Link Token"
            }
          },
          "token": {
            "buttons": {
              "tokens": "Tokens"
            }
          }
        }
      },
      "label": {
        "delete": "Supprimer",
        "duplicate": "Dupliquer",
        "edit": "Modifier"
      },
      "template": {
        "caption": "The Template Name will help you tell the templates apart, so make it unique and identifiable.",
        "character_count": "Character left: %{count} / %{limit}",
        "create_new": "Créer un nouveau",
        "description": "Configure Message Templates for all channels to be used in Autoflow, for Bulk Actions, Folder Movements and as Quick Replies in all stages of the hiring process.",
        "email": {
          "name": "Email Template Name",
          "subject_line": "Subject Line",
          "tab": "E-mail",
          "title": "Email Templates"
        },
        "input": {
          "search_bar": {
            "placeholder": "Search Message Templates"
          }
        },
        "messenger": {
          "name": "Messenger Template Name",
          "tab": "Messenger",
          "title": "Messenger Templates"
        },
        "sms": {
          "name": "SMS Template Name",
          "tab": "SMS",
          "title": "SMS Templates"
        },
        "text": {
          "approved_by_meta": "Approved by Meta",
          "created_by_admin": "Created by Admin",
          "created_on": "Created on %{date} by %{name}",
          "last_edited_on": "Edited on %{date} by %{name}",
          "linked_campaigns_description": "This Message Template is being used for Autoflow in the following Campaigns",
          "update_from_template": "Update Message from Template",
          "update_from_template_confirmation": "This message is currently linked to a Message Template. If you edit it, it will be unlinked from the Template and any other changes will have to be done manually to this Autoflow action as any bulk edits to the Template will no longer be applied to it.",
          "update_template": "Update Message Template",
          "update_template_confirmation": "By updating this Message Template, all Autoflow actions using it will be updated as well. Do you want to proceed?"
        },
        "title": "Message Templates",
        "whatsapp": {
          "name": "WhatsApp Template Name",
          "tab": "WhatsApp",
          "title": "WhatsApp Templates"
        }
      },
      "tokens": {
        "aspiring_minds_assessment_link": {
          "description": "Lien d'évaluation Aspiring Minds",
          "title": "Lien vers l'évaluation Aspiring Minds"
        },
        "aspiring_minds_login_link": {
          "description": "Lien personnalisé vers la connexion Aspiring Minds",
          "title": "Lien de connexion Aspiring Minds"
        },
        "aspiring_minds_password": {
          "description": "Mot de passe Aspiring Minds",
          "title": "Mot de passe Aspiring Minds"
        },
        "aspiring_minds_svar_url": {
          "description": "Lien d'évaluation SVAR Aspiring Minds",
          "title": "Lien d'évaluation SVAR Aspiring Minds"
        },
        "aspiring_minds_username": {
          "description": "Nom d'utilisateur Aspiring Minds",
          "title": "Nom d'utilisateur Aspiring Minds"
        },
        "assigned_recruiter": {
          "description": "Nom complet du recruteur assigné",
          "title": "Recruteur assigné"
        },
        "assigned_recruiter_calendar_scheduler_url": {
          "description": "Lien de l'agenda du recruteur assigné",
          "title": "URL de l'agenda du recruteur assigné"
        },
        "button": {
          "name": "Tokens"
        },
        "calendar_date": {
          "description": "Date de rendez-vous de Mon Agenda",
          "title": "Date calendrier"
        },
        "calendar_time_end": {
          "description": "Fin de l'heure du rendez-vous dans Mon Calendrier",
          "title": "Fin de l'horaire du calendrier"
        },
        "calendar_time_start": {
          "description": "Début de l'heure du rendez-vous dans Mon calendrier",
          "title": "Début de l'horaire du calendrier"
        },
        "call_center_agent_assessment_url": {
          "description": "Lien personnalisé vers l'évaluation de l'agent du centre d'appel SHL",
          "title": "URL d'évaluation de l'agent du centre d'appels SHL"
        },
        "call_center_agent_secondary_assessment_url": {
          "description": "Personalized link to SHL Call Center Agent Secondary assessment",
          "title": "SHL Call Center Agent Secondary Assessment URL"
        },
        "candidate_first_name": {
          "description": "Prénom du candidat",
          "title": "Prénom du candidat"
        },
        "candidate_id": {
          "description": "Identifiant de la candidature",
          "title": "Identifiant du candidat"
        },
        "candidate_name": {
          "description": "Nom complet du candidat",
          "title": "Nom du candidat"
        },
        "channel_optin_url": {
          "description": "Lien vers la page d'opt-in de WhatsApp",
          "title": "URL d'opt-in de WhatsApp"
        },
        "chat_attachment": {
          "description": "ID de chat personnalisé pour demander des fichiers par Messenger",
          "title": "Pièce jointe au chat"
        },
        "choose_position_link": {
          "description": "Lien personnalisé pour afficher les cartes de travail sur Messenger",
          "title": "Choisir le lien de l'offre"
        },
        "city": {
          "description": "Lieu d'emploi de la campagne",
          "title": "Ville de la campagne"
        },
        "company": {
          "description": "Nom de votre entreprise",
          "title": "Entreprise"
        },
        "emmersion_sign_in_url": {
          "description": "Sign In link to Emmersion assessments",
          "title": "Lien d'Emmersion"
        },
        "hireiq_assessment_link": {
          "description": "Lien personnalisé vers l'évaluation Hire IQ",
          "title": "Lien vers Hire IQ"
        },
        "hireiq_pin": {
          "description": "Hire IQ PIN number",
          "title": "Hire IQ PIN"
        },
        "insert_picture": {
          "description": "Insérer une image à envoyer par e-mail ou Messenger",
          "title": "Insérer une image"
        },
        "insert_video": {
          "description": "Insérer une vidéo à envoyer par e-mail ou Messenger",
          "title": "Insérer une vidéo"
        },
        "interview_page_url": {
          "description": "Lien personnalisé vers le formulaire de la page d'atterrisage",
          "title": "Lien Interview"
        },
        "job_landing_page_url": {
          "description": "Lien vers la page de description du poste",
          "title": "URL de la page de destination du travail"
        },
        "job_title": {
          "description": "Emploi pour lequel le candidat a postulé",
          "title": "Titre du poste"
        },
        "mail_attachment": {
          "description": "ID email personnalisé pour demander des fichiers par email",
          "title": "Pièce jointe au courrier"
        },
        "messenger_call_to_action_link": {
          "description": "Messenger Call To Action Link",
          "title": "Messenger Call To Action Link"
        },
        "messenger_interview_link": {
          "description": "Lien personnalisé pour déclencher des questions d'entretien sur Messenger",
          "title": "Lien Interview Messenger"
        },
        "my_calendar_scheduler_url": {
          "description": "Lien vers votre agenda",
          "title": "URL de mon agenda"
        },
        "onboarding_form_url": {
          "description": "Lien vers le formulaire d'intégration en ligne",
          "title": "URL du formulaire d'intégration"
        },
        "onboarding_link": {
          "description": "Lien vers le chatbot d'intégration",
          "title": "Lien d'intégration"
        },
        "pre_employment_chat_assessment_url": {
          "description": "Lien personnalisé vers l'évaluation SHL Chat",
          "title": "SHL Pre Employment Chat Assessment URL"
        },
        "reapply_retention_period": {
          "description": "Période de refroidissement de la campagne",
          "title": "Période durant laquelle le candidat ne peut pas postuler à nouveau"
        },
        "recruiter_first_name": {
          "description": "Prénom du recruteur assigné",
          "title": "Prénom du recruteur assigné"
        },
        "referee": {
          "description": "Nom de la personne qui a référé un candidat",
          "title": "personne référée"
        },
        "rejected_reasons": {
          "description": "Motifs de rejet du candidat",
          "title": "Motifs de rejet"
        },
        "scheduled_at": {
          "description": "Date prévue de l'entretien du candidat",
          "title": "Prévu à"
        },
        "scheduler_url": {
          "description": "Lien vers le planificateur du centre de recrutement de la campagne",
          "title": "Lien Planificateur"
        },
        "shortlisted_reasons": {
          "description": "Raisons de présélection du candidat",
          "title": "Motifs de présélection"
        },
        "site_location": {
          "description": "Site de l'entreprise ou succursale où le nouvel employé sera assigné ou formé",
          "title": "Localisation du site"
        },
        "svar_spoken_english_assessment_url": {
          "description": "Personalized link to SVAR Spoken English assessment",
          "title": "SVAR Spoken English Assessment URL"
        },
        "training_batch": {
          "description": "Lot ou vague de stagiaires pour l'onboarding",
          "title": "Lot d'entraînement"
        },
        "training_date": {
          "description": "Date de la formation dans le cadre de l'intégration",
          "title": "Date de la formation"
        },
        "training_program": {
          "description": "Classe ou programme de formation pour l'intégration",
          "title": "Programme de formation"
        },
        "training_time": {
          "description": "Temps de formation d'intégration",
          "title": "Heure de la formation"
        },
        "training_venue": {
          "description": "Lieu de formation d'intégration",
          "title": "Emplacement de la formation"
        },
        "upcoming_scheduled_appointment": {
          "description": "Date prévue de l'entretien du candidat",
          "title": "Rendez-vous planifié à venir"
        },
        "whatsapp_call_to_action_link": {
          "description": "Whatsapp To Action Link",
          "title": "Whatsapp Call To Action Link"
        },
        "workday_candidate_id": {
          "description": "Candidate ID from Workday",
          "title": "Workday Candidate ID"
        }
      }
    },
    "prompt": {
      "label": {
        "add_a_question": "Ajouter une question",
        "create_new": "Créer un nouveau",
        "delete": "Supprimer",
        "question_set": {
          "name": "Question Set Name",
          "search": "Search Question Sets",
          "send": "Send Question Set"
        }
      },
      "text": {
        "created_by": "Created by %{name} on %{date}",
        "edited_by": "Edited by %{name} on %{date}",
        "question_set": {
          "cannot_be_deleted": "This Question Set cannot be deleted as it's being used by Autoflow in the following campaigns",
          "description": "Configure sets of questions from Question Templates to be used in Autoflow to trigger Follow up Question to Leads at any point of the process. ",
          "name_description": "This name will help you identify your Question Set when configuring an Autoflow. We recommend that you make it unique and easy to identify.",
          "title": "Question Sets",
          "used_in_campaigns": "This Question Set cannot be deleted as it's being used in the following Campaigns"
        }
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "E-mail",
        "first_name": "Prénom",
        "last_name": "Nom de famille",
        "new_recording": "Nouvel enregistrement",
        "phone_number": "Numéro de téléphone",
        "record_now": "Enregistrer maintenant",
        "start_camera": "Démarrer la caméra",
        "stop_recording": "Arrêter d'enregistrer",
        "take_picture": "Prendre une photo"
      },
      "notes": {
        "video_limit": "La durée de réponse vidéo maximale est de 1 minute."
      },
      "show": {
        "about": "Au sujet de"
      },
      "success": {
        "answers_message": "Vos réponses ont été soumises avec succès.",
        "title": "Merci"
      }
    }
  },
  "helpers": {
    "select": {
      "prompt": "Veuillez sélectionner"
    },
    "submit": {
      "create": "Créer un(e) %{model}",
      "submit": "Enregistrer ce(tte) %{model}",
      "update": "Modifier ce(tte) %{model}"
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Ajouter une image",
      "apply": "Postuler",
      "change_image": "Changer l'image",
      "save": "Enregistrer",
      "select_page_helper": "Lier des pages Facebook signifie que toute personne qui discute avec votre bot peut voir cette campagne. Pour que cette campagne n'apparaisse pas sur le chatbot, laissez ce champ vide. Ci-dessous, vous pouvez voir tous les liens d'entretien de Messenger pour diriger directement les candidats vers l'entretien chatbot, cela est disponible même si la page Facebook n'est pas liée à cette campagne (indiquée par l'icône de verrouillage).",
      "view_job_description": "Voir la description du poste"
    },
    "google": {
      "google_job": "Emplois Google (bêta)",
      "job_par": {
        "best_practice": "les meilleures pratiques",
        "first": "Les emplois répertoriés sur Google apparaîtront directement dans les résultats de recherche Google.",
        "head": "Activer l'indexation Google de la page de destination.",
        "help_center": "notre centre d'aide",
        "second": "Les candidats qui cliquent sur ces listes d'emplois sont redirigés vers la page d'accueil des offres d'emplois Talkpush, où ils peuvent choisir de postuler et de répondre immédiatement aux questions de sélection. Vous pouvez en savoir plus à ce sujet dans",
        "third": "Si votre emploi n'apparaît pas dans les offres d'emploi publiées de Google, assurez-vous de suivre ces"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Le titre du poste, le pays, la région et une longue description sont requis. "
      }
    },
    "landing": {
      "copy": "Copier",
      "first": "URL de la page de destination",
      "save": "Enregistrer"
    },
    "tecoloco": {
      "job_par": {
        "first": "Jobs that are listed in Tecoloco will appear in the Tecoloco feed.",
        "head": "Advertise the job opening on Tecoloco Jobs",
        "help_center": "notre centre d'aide",
        "second": "Candidates who apply to these job listings are forwarded to the Talkpush Job Landing Page, where they can apply and immediately complete the screening questions. You can learn more about it in"
      },
      "tecoloco_jobs": "Tecoloco Jobs"
    }
  },
  "job_landing_page": {
  },
  "jobs": {
    "salary_types": {
      "annually": "Annuellement",
      "biweekly": "Bihebdomadaire",
      "daily": "tous les jours",
      "hourly": "Hourly",
      "monthly": "Mensuel",
      "one-time": "Une fois",
      "weekly": "hebdomadaire"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "milliard",
          "million": "million",
          "quadrillion": "million de milliards",
          "thousand": "millier",
          "trillion": "billion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "octet",
            "other": "octets"
          },
          "eb": "Eo",
          "gb": "Go",
          "kb": "ko",
          "mb": "Mo",
          "pb": "Po",
          "tb": "To"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 1
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy-applicant/",
  "setup_questions": {
    "onboarding_title": "Questions d'onboarding",
    "question_types": {
      "audio": "l'audio",
      "text": "Texte"
    },
    "update": "Mise à jour"
  },
  "time": {
    "am": "am",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%d %B %Y %Hh %Mmin %Ss",
      "long": "%A %d %B %Y %Hh%M",
      "short": "%d %b %Hh%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "minute": "1 minute",
    "minutes": "%{minutes} minutes",
    "pm": "pm",
    "second": "1 seconde",
    "seconds": "%{seconds} seconds",
    "time_left": "Time Left: %{minutes} %{seconds}"
  }
});

window.t = I18n.t.bind(I18n);
window.l = I18n.l.bind(I18n);
I18n.locale = document.documentElement.lang;
